import { useTranslation } from "react-i18next";
import { useCookies } from "react-cookie";
import { useState } from "react";
import {
  retrieveStockDividend,
  retrieveStockInfo,
  retrieveStockInfomation,
} from "../../Services/StockSessionApiService";
import { useEffect } from "react";
import data from "../../Assets/stock-info.json";
import $ from "jquery";
import Bod from "../../Components/StockInfo/Bod";
import { DateTimer } from "../../Components/Timer/dateTimer";
import { Dropdown } from "primereact/dropdown";
import { Avatar } from "primereact/avatar";
import DividendDialog from "../../Components/PrimeReact/Dividend/dialog";
import LogoHeader from "../../Components/PrimeReact/logoBanner";
import { Dialog } from "primereact/dialog";
import { useAuthHeader } from "../../auth/AuthService";
import { Tooltip } from "primereact/tooltip";

export default function StockInfo() {
  const { t, i18n } = useTranslation();
  const [cookies, setCookie] = useCookies(["icode", "bType"]);
  const [dialogVisible, setDialogVisible] = useState();
  const [dialogContent, setDialogContent] = useState();
  const authHeader = useAuthHeader();

  const [stocks, setStocks] = useState([]);
  const [stock, setStock] = useState({});
  const [stockInfomation, setStockInfomation] = useState({});
  const [dividend, setDividend] = useState({});

  const [board, setBoard] = useState(cookies.bType ? cookies.bType : "M");
  const [icode, setIcode] = useState("");

  const boards = [
    { name: t("Main Board"), value: "M" },
    { name: t("Growth Board"), value: "G" },
  ];
  const [icodes, setIcodes] = useState([]);

  const onChangeBoard = (e) => {
    let val = e.value;
    setBoard(val);
    setCookie("bType", val);
    if (val == "G") {
      setIcode("KH1000150008");
    } else {
      setIcode("KH1000100003");
    }
  };

  const onChangeStock = (e) => {
    let val = e.value;
    setIcode(val);
    setCookie("icode", val);
  };

  // INITIALIZE
  async function init() {
    !cookies.bType && setCookie(board);
    await retrieveStockInfo(cookies.bType, null, authHeader())
      .then((response) => {
        let data = response.data.data;
        if (data) {
          let icode = cookies.icode;
          if (!icode || !data.issues.map((v) => v.icode).includes(icode)) {
            icode = board == "G" ? "KH1000150008" : "KH1000100003";
            setCookie("icode", icode);
          }
          setIcode(icode);
          setStocks(data.stock);
          let icodes = data.issues
            .sort(function (a, b) {
              if (a.esymbol < b.esymbol) return -1;
              if (a.esymbol > b.esymbol) return 1;
              return 0;
            })
            .map((v) => ({ name: v.esymbol, value: v.icode }));
          setIcodes(icodes);
        }
      })
      .catch((error) => console.log(error));
  }

  async function getStockInfo() {
    icode &&
      (await retrieveStockInfomation(board, icode, authHeader())
        .then((response) => {
          let v = response.data.data;
          let obj = {};
          let oneYearTrade = v.one_year_trd_list;
          let firstClosingPrice = 0;
          let lastClosingPrice = 0;
          let totalPrice = 0;
          let totalVal = 0;
          let weekHigh = 0;
          let weekLow = 0;
          let avgPrice = 0;
          let avgVal = 0;
          let chPct = 0;
          if (oneYearTrade.length) {
            if (oneYearTrade.length > 1) {
              firstClosingPrice = oneYearTrade[0].bprice;
              lastClosingPrice = oneYearTrade[oneYearTrade.length - 1].cprice;
            } else {
              firstClosingPrice = lastClosingPrice =
                oneYearTrade[oneYearTrade.length - 1].bprice;
            }
            oneYearTrade.map((v) => {
              totalPrice += v.cprice;
              totalVal += v.ctamount;
              if (v.cprice > weekHigh) {
                weekHigh = v.cprice;
              }
              if (weekLow == 0 || (weekLow > v.cprice && v.cprice)) {
                weekLow = v.cprice;
              }
            });
            avgPrice = totalPrice / oneYearTrade.length;
            avgVal = totalVal / oneYearTrade.length;
            chPct = (lastClosingPrice - firstClosingPrice) / firstClosingPrice;
          }

          let year =
            (v.issue_infos[0] &&
              new Date(v.issue_infos[0].iyear).getFullYear()) ??
            new Date().getFullYear() - 1;

          obj["annualTradingStatic"] = {
            market_cap: [],
            full_market_cap: [],
            last_price: [],
            change: [],
            avg_price: [],
            high: [],
            low: [],
            val_day: [],
            turn_over: [],
          };

          obj["valuationRatios"] = {
            pe: [],
            pbv: [],
            div: [],
            dpr: [],
            cash_div: [],
          };

          obj["performanceRatios"] = {
            roe: [],
            roa: [],
            deptRatio: [],
            currentRatio: [],
          };

          obj["balanceSheet"] = {
            asset: [],
            ppe: [],
            curAsset: [],
            investory: [],
            ar: [],
            cash: [],
            equity: [],
            shareCap: [],
            retainedEarning: [],
            liabilities: [],
            curLiablities: [],
            ap: [],
          };

          obj["incomeStatement"] = {
            revenue: [],
            grossProfit: [],
            ebit: [],
            netIncome: [],
            eps: [],
          };

          obj["cashFlowStatement"] = {
            operatingCashFlow: [],
            investingCashFlow: [],
            financingCashFlow: [],
            netCashFlow: [],
          };

          obj["yearly"] = [];

          icode &&
            Object.keys(v.yearly).map((val, i) => {
              let index = Object.keys(v.yearly).length - i - 1;
              let issueInfo = v.issue_infos[i];
              let issueInfoPrevYear = v.issue_infos[i + 1];
              let dataYearly = v.yearly[year - i];

              console.log(year - i);

              obj["annualTradingStatic"]["market_cap"][index] =
                dataYearly && dataYearly.yearly_mkt_cap;
              obj["annualTradingStatic"][`full_market_cap`][index] =
                data[icode][`full_market_cap_${i}`];
              obj["annualTradingStatic"][`last_price`][index] =
                dataYearly && dataYearly.yearly_last_price;
              obj["annualTradingStatic"][`avg_price`][index] =
                dataYearly && dataYearly.yearly_avg_price;
              obj["annualTradingStatic"][`change`][index] =
                dataYearly &&
                dataYearly.yearly_ch_pct != null &&
                (dataYearly.yearly_ch_pct >= 0
                  ? (dataYearly.yearly_ch_pct * 100).toFixed(2) + " %"
                  : "(" +
                    (Math.abs(dataYearly.yearly_ch_pct) * 100).toFixed(2) +
                    " %)");
              obj["annualTradingStatic"][`high`][index] =
                dataYearly && dataYearly.yearly_high;
              obj["annualTradingStatic"][`low`][index] =
                dataYearly && dataYearly.yearly_low;
              obj["annualTradingStatic"][`val_day`][index] =
                dataYearly && dataYearly.yearly_val_day;
              obj["annualTradingStatic"][`turn_over`][index] =
                issueInfo && issueInfo.iturnOverRatia;

              obj["valuationRatios"]["pe"][index] = issueInfo && issueInfo.ipe;
              obj["valuationRatios"]["pbv"][index] =
                issueInfo && issueInfo.ipbv;
              obj["valuationRatios"]["div"][index] =
                issueInfo &&
                dataYearly &&
                dataYearly.yearly_last_price &&
                issueInfo.icashDIV / dataYearly.yearly_last_price &&
                Math.abs(
                  (issueInfo.icashDIV / dataYearly.yearly_last_price) * 100
                ).toFixed(2) + " %";
              obj["valuationRatios"]["dpr"][index] =
                issueInfo &&
                issueInfo.idpr &&
                (issueInfo.idpr > 0
                  ? Math.abs(issueInfo.idpr).toFixed(2) + " %"
                  : "(" + Math.abs(issueInfo.idpr).toFixed(2) + " %)");
              obj["valuationRatios"]["cash_div"][index] =
                issueInfo && issueInfo.icashDIV;

              let equity_pre_year =
                issueInfoPrevYear && issueInfoPrevYear.iequity;
              let equity_curr_year = issueInfo && issueInfo.iequity;
              let net_income = issueInfo && issueInfo.inetIncome;
              let asset_pre_year =
                issueInfoPrevYear && issueInfoPrevYear.iassets;
              let asset_curr_year = issueInfo && issueInfo.iassets;
              let prevYear = year - 1;
              if (prevYear == 2014 && icode == "KH1000060009") {
                equity_pre_year = 428859840000;
                asset_pre_year = 897581640000;
              }
              if (equity_pre_year) {
                equity_curr_year = (equity_pre_year + equity_curr_year) / 2;
              }
              if (asset_pre_year) {
                asset_curr_year = (asset_pre_year + asset_curr_year) / 2;
              }
              let roe = (net_income / equity_curr_year) * 100;
              let roa = (net_income / asset_curr_year) * 100;
              let cur_ratio =
                issueInfo && (issueInfo.icurrAsset / issueInfo.icurrLiab) * 100;

              obj["performanceRatios"]["roe"][index] =
                roe &&
                (roe < 0
                  ? "(" + Math.abs(roe).toFixed(2) + " %)"
                  : roe.toFixed(2) + " %");
              obj["performanceRatios"]["roa"][index] =
                roa &&
                (roa < 0
                  ? "(" + Math.abs(roa).toFixed(2) + " %)"
                  : roa.toFixed(2) + " %");
              obj["performanceRatios"]["deptRatio"][index] =
                issueInfo &&
                (issueInfo.deptRatio
                  ? issueInfo.deptRatio.toFixed(2) + " %"
                  : "0.00%");
              obj["performanceRatios"]["currentRatio"][index] =
                cur_ratio && cur_ratio.toFixed(2) + " %";

              obj["balanceSheet"]["asset"][index] =
                issueInfo && issueInfo.iassets && issueInfo.iassets / 1000000;
              obj["balanceSheet"]["ppe"][index] =
                issueInfo && issueInfo.ippe && issueInfo.ippe / 1000000;
              obj["balanceSheet"]["curAsset"][index] =
                issueInfo &&
                issueInfo.icurrAsset &&
                issueInfo.icurrAsset / 1000000;
              obj["balanceSheet"]["investory"][index] =
                issueInfo && issueInfo.iinvest && issueInfo.iinvest / 1000000;
              obj["balanceSheet"]["ar"][index] =
                issueInfo && issueInfo.iar && issueInfo.iar / 1000000;
              obj["balanceSheet"]["cash"][index] =
                issueInfo && issueInfo.icash && issueInfo.icash / 1000000;
              obj["balanceSheet"]["equity"][index] =
                issueInfo && issueInfo.iequity && issueInfo.iequity / 1000000;
              obj["balanceSheet"]["shareCap"][index] =
                issueInfo &&
                issueInfo.ishareCap &&
                issueInfo.ishareCap / 1000000;
              obj["balanceSheet"]["retainedEarning"][index] =
                issueInfo &&
                issueInfo.iretainedEarn &&
                issueInfo.iretainedEarn / 1000000;
              obj["balanceSheet"]["liabilities"][index] =
                issueInfo && issueInfo.iliab && issueInfo.iliab / 1000000;
              obj["balanceSheet"]["curLiablities"][index] =
                issueInfo &&
                issueInfo.icurrLiab &&
                issueInfo.icurrLiab / 1000000;
              obj["balanceSheet"]["ap"][index] =
                issueInfo && issueInfo.iap && issueInfo.iap / 1000000;

              obj["incomeStatement"]["revenue"][index] =
                issueInfo && issueInfo.irevenue && issueInfo.irevenue / 1000000;
              obj["incomeStatement"]["grossProfit"][index] =
                issueInfo &&
                issueInfo.igrossProfit &&
                issueInfo.igrossProfit / 1000000;
              obj["incomeStatement"]["ebit"][index] =
                issueInfo &&
                issueInfo.iebit &&
                (issueInfo.iebit < 0
                  ? "(" + Math.abs(issueInfo.iebit / 1000000) + " )"
                  : issueInfo.iebit / 1000000);
              obj["incomeStatement"]["netIncome"][index] =
                issueInfo &&
                issueInfo.inetIncome &&
                (issueInfo.inetIncome < 0
                  ? "(" + Math.abs(issueInfo.inetIncome / 1000000) + " )"
                  : issueInfo.inetIncome / 1000000);
              obj["incomeStatement"]["eps"][index] =
                issueInfo &&
                issueInfo.ieps &&
                (issueInfo.ieps < 0
                  ? "(" + Math.abs(issueInfo.ieps) + " )"
                  : issueInfo.ieps);

              obj["cashFlowStatement"]["operatingCashFlow"][index] =
                issueInfo && issueInfo.iocashFlow;
              obj["cashFlowStatement"]["investingCashFlow"][index] =
                issueInfo && issueInfo.iinvesCashFlow;
              obj["cashFlowStatement"]["financingCashFlow"][index] =
                issueInfo && issueInfo.ifinancCashFlow;
              obj["cashFlowStatement"]["netCashFlow"][index] =
                issueInfo && issueInfo.inetCashFlow;
              obj["cashFlowStatement"].audit =
                v.issue_infos[0] &&
                (i18n.language == "kh"
                  ? v.issue_infos[0].iaudFirmKH
                  : v.issue_infos[0].iaudFirm);
              $("#financial-report").html(
                v.issue_infos[0] && v.issue_infos[0].ifinancialReport
              );

              obj["yearly"][index] = year - i;
            });

          obj["week52"] = {
            avg_price: avgPrice,
            high: weekHigh,
            low: weekLow,
            change:
              oneYearTrade.length &&
              (chPct >= 0
                ? (chPct * 100).toFixed(2) + " %"
                : "(" + Math.abs(chPct * 100).toFixed(2) + " %)"),
            val_day: oneYearTrade.length ? avgVal : null,
          };

          obj["ipoInformaton"] = {
            ipoPrice: v.issue_po_infos
              ? v.issue_po_infos
                ? v.issue_po_infos.iipoprice
                : 0
              : "-",
            issuedShare: v.issue_po_infos
              ? v.issue_po_infos.iissuedshares
                ? v.issue_po_infos.iissuedshares
                : 0
              : "-",
            listedShare: v.issue_po_infos
              ? v.issue_po_infos.ilistedShares
                ? v.issue_po_infos.ilistedShares
                : 0
              : "-",
            nonListedShare: v.issue_po_infos
              ? v.issue_po_infos.inonListedShares
                ? v.issue_po_infos.inonListedShares
                : 0
              : "-",
            firstTradeDate: v.issue_po_infos
              ? v.issue_po_infos.ifirstTrdDate
                ? v.issue_po_infos.ifirstTrdDate
                : 0
              : "-",
            underWriter: v.issue_po_infos
              ? v.issue_po_infos.iunderwriter
                ? v.issue_po_infos.iunderwriter
                : 0
              : "-",
          };

          obj["companyProfile"] = {
            stockClassify:
              v.issue_profiles &&
              (i18n.language == "kh"
                ? v.issue_profiles.istockClsKH
                : v.issue_profiles.istockCls),
            businessHighlight:
              v.issue_profiles &&
              (i18n.language == "kh"
                ? v.issue_profiles.ibusShortKH
                : v.issue_profiles.ibusShort),
            businessHighlightDialog:
              v.issue_profiles &&
              (i18n.language == "kh"
                ? v.issue_profiles.ibusKH
                : v.issue_profiles.ibus),
            noStaff:
              v.issue_profiles &&
              v.issue_profiles.inoStaff.toLocaleString("en-US"),
            subShare:
              v.issue_profiles &&
              (i18n.language == "kh"
                ? v.issue_profiles.isubShareKH
                : v.issue_profiles.isubShare),
            holderStructure:
              v.issue_profiles &&
              (i18n.language == "kh"
                ? v.issue_profiles.isholderStructureKH
                : v.issue_profiles.isholderStructure),
            website: v.issue_profiles && v.issue_profiles.iwebsite,
            note:
              v.issue_profiles &&
              (i18n.language == "kh"
                ? v.issue_profiles.inoteKH
                : v.issue_profiles.inote),
          };

          $("#underwriter").html(obj.ipoInformaton.underWriter);
          $("#sub-share").html(obj.companyProfile.subShare);
          $("#holder-structure").html(obj.companyProfile.holderStructure);
          $("#business-highlight").html(
            (obj.companyProfile.businessHighlight
              ? obj.companyProfile.businessHighlight
              : "") +
              "<div class='text-end text-yellow pe-1 btn-read-more'><i><u>Read More</u></i></div>"
          );
          setDialogContent(
            v.issue_profiles &&
              (i18n.language == "kh"
                ? v.issue_profiles.ibusKH
                : v.issue_profiles.ibus)
          );
          $("#company-note").html(
            obj.companyProfile && obj.companyProfile.note
          );

          setStockInfomation(obj);
        })
        .catch((error) => console.log(error)));
  }

  async function setIssueAndStock(icode) {
    let stock =
      icode && stocks && stocks.filter((stock) => stock.icode == icode)[0];
    setStock(stock);
    icode &&
      stocks &&
      (await retrieveStockDividend(cookies.bType, icode, authHeader())
        .then((response) => {
          let v = response.data.data;
          let diviSign = 1;
          let txtdiv = "";
          if (v.divi == 1) {
            txtdiv = (
              <img src="/img/d-sign.png" className="vertical-align-super" />
            );
            diviSign = 1;
          }

          if (v.xd == 1) {
            txtdiv = (
              <img src="/img/xd-sign.png" className="vertical-align-super" />
            );
            diviSign = 2;
          }

          let divi = {
            stock: stock.isymbol,
            lp: stock.ilp,
            diviSign: diviSign,
            txtdiv: txtdiv,
            type_of_dividend: v?.dividend?.itypeDividend,
            dividend_per_share: v?.dividend?.idividendPerShare,
            ex_dividend_date: v?.dividend?.iexDividendDate,
            record_date: v?.dividend?.irecodeDate,
            payment_date: v?.dividend?.ipaymentDate,
            link: v?.dividend?.iwebsiteLink,
          };

          setDividend(divi);
        })
        .catch((error) => console.log(error)));
  }

  useEffect(() => {
    getStockInfo();
    setIssueAndStock(icode);
  }, [icode, stocks]);

  useEffect(() => {
    init();
  }, [board, i18n.language]);

  const icodeOptionTemplate = (option) => {
    return (
      <div className="flex align-items-center">
        <Avatar
          image={`/img/issue_logo_icons/${option?.value}_logo.jpg`}
          shape="circle"
        />
        &nbsp;&nbsp;<div>{option.name}</div>
      </div>
    );
  };

  const selectedIcodeTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <Avatar
            image={`/img/issue_logo_icons/${option?.value}_logo.jpg`}
            shape="circle"
            className="absolute"
          />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <div>{option.name}</div>
        </div>
      );
    }
    return <span>{props.placeholder}</span>;
  };

  const selectedBoardTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <div>{option.name}</div>
        </div>
      );
    }
    return <span>{props.placeholder}</span>;
  };

  function onShowDialog() {
    setDialogVisible(true);
    $("#business-highlight-dialog").html(dialogContent);
  }

  return (
    <>
      <LogoHeader />

      <div className="col-12 -mt-3">
        <div className="grid p-2">
          <div
            className="col-12 md:col-8 card p-3 shadow-3 border-round-lg border-1"
            style={{
              backgroundImage:
                "linear-gradient(0deg, rgba(232,76,4,1) 0%, rgba(232,128,80,1) 100%)",
            }}
          >
            <div className="grid align-items-center">
              <div className="col-4 py-0 mt-2  border-right-2">
                <Dropdown
                  value={board}
                  onChange={onChangeBoard}
                  options={boards}
                  valueTemplate={selectedBoardTemplate}
                  optionLabel="name"
                  placeholder="Select a Board"
                  className="w-full border-round-lg"
                />
              </div>
              <div className="col-4 pb-0">
                <Dropdown
                  value={icode}
                  onChange={onChangeStock}
                  options={icodes}
                  valueTemplate={selectedIcodeTemplate}
                  itemTemplate={icodeOptionTemplate}
                  optionLabel="name"
                  placeholder="Select a Stock"
                  className="w-full border-round-lg"
                />
              </div>
              <div className="col-4 pb-0">
                {stock &&
                  (i18n.language == "kh" ? stock.iname : stock.inameEnglish)}
                &nbsp;
                <DividendDialog issue={dividend}></DividendDialog>
              </div>
            </div>
          </div>
          <div className="col-12 md:col-4 flex align-items-center justify-content-center md:justify-content-end">
            <div className="flex-row line-height-3">
              <span className="flex justify-content-end font-bold">
                {t("Date")} : <DateTimer type={1} />
              </span>
              <span className="flex justify-content-end font-bold">
                {t("Time")} : <DateTimer type={3} />{" "}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="col-12">
        <div className="grid">
          <div className="col-12 md:col-6 md:pr-2">
            <div className="card p-3 shadow-3 border-round-lg bg-card">
              <table className="w-full">
                <tbody className="text-sm">
                  <tr className="text-yellow-500 font-bold">
                    <td
                      className="py-1 border-bottom-1 border-blue-700"
                      colSpan="2"
                    >
                      {t("52-Week Data")}
                    </td>
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      {t("Avg. Price")}
                    </td>
                    <td className="text-right border-bottom-1 border-blue-700">
                      {stockInfomation.week52 &&
                      stockInfomation.week52.avg_price
                        ? stockInfomation.week52.avg_price.toLocaleString(
                            "en-US",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )
                        : "-"}
                    </td>
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      {t("High")}
                    </td>
                    <td className="text-right border-bottom-1 border-blue-700">
                      {stockInfomation.week52 && stockInfomation.week52.high
                        ? stockInfomation.week52.high.toLocaleString("en-US")
                        : "-"}
                    </td>
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      {t("Low")}
                    </td>
                    <td className="text-right border-bottom-1 border-blue-700">
                      {stockInfomation.week52 && stockInfomation.week52.low
                        ? stockInfomation.week52.low.toLocaleString("en-US")
                        : "-"}
                    </td>
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      {t("% Change")}
                    </td>
                    <td className="text-right border-bottom-1 border-blue-700">
                      {stockInfomation.week52 && stockInfomation.week52.change
                        ? stockInfomation.week52.change
                        : "-"}
                    </td>
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      {t("Value/Day")}
                    </td>
                    <td className="text-right border-bottom-1 border-blue-700">
                      {stockInfomation.week52 &&
                        (stockInfomation.week52.val_day != null
                          ? stockInfomation.week52.val_day.toLocaleString(
                              "en-US",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )
                          : "-")}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="card p-3 shadow-3 border-round-lg mt-3 bg-card">
              <table className="w-full">
                <tbody className="text-sm">
                  <tr className="text-yellow-500 font-bold">
                    <td
                      className="py-1 border-bottom-1 border-blue-700"
                      colSpan="2"
                    >
                      {t("IPO Information")}
                    </td>
                  </tr>
                  <tr>
                    <td className="py-1 border-bottom-1 border-blue-700 text-blue">
                      {t("IPO Price")}
                    </td>
                    <td className="text-right border-bottom-1 border-blue-700">
                      {stockInfomation.ipoInformaton &&
                        stockInfomation.ipoInformaton.ipoPrice &&
                        stockInfomation.ipoInformaton.ipoPrice.toLocaleString(
                          "en-US"
                        )}
                    </td>
                  </tr>
                  <tr>
                    <td className="py-1 border-bottom-1 border-blue-700 text-blue">
                      {t("No. of issued shares")}
                    </td>
                    <td className="text-right border-bottom-1 border-blue-700">
                      {stockInfomation.ipoInformaton &&
                        stockInfomation.ipoInformaton.issuedShare &&
                        stockInfomation.ipoInformaton.issuedShare.toLocaleString(
                          "en-US"
                        )}
                    </td>
                  </tr>
                  <tr>
                    <td className="py-1 border-bottom-1 border-blue-700 text-blue">
                      {t("No. of listed shares")}
                    </td>
                    <td className="text-right border-bottom-1 border-blue-700">
                      {stockInfomation.ipoInformaton &&
                        stockInfomation.ipoInformaton.listedShare &&
                        stockInfomation.ipoInformaton.listedShare.toLocaleString(
                          "en-US"
                        )}
                    </td>
                  </tr>
                  <tr>
                    <td className="py-1 border-bottom-1 border-blue-700 text-blue">
                      {t("No. of non listed shares")}
                    </td>
                    <td className="text-right border-bottom-1 border-blue-700">
                      {stockInfomation.ipoInformaton &&
                        stockInfomation.ipoInformaton.nonListedShare &&
                        stockInfomation.ipoInformaton.nonListedShare.toLocaleString(
                          "en-US"
                        )}
                    </td>
                  </tr>
                  <tr>
                    <td className="py-1 border-bottom-1 border-blue-700 text-blue">
                      {t("1st trading date")}
                    </td>
                    <td className="text-right border-bottom-1 border-blue-700">
                      {stockInfomation.ipoInformaton &&
                        stockInfomation.ipoInformaton.firstTradeDate}
                    </td>
                  </tr>
                  <tr>
                    <td className="py-1 border-bottom-1 border-blue-700 text-blue">
                      {t("Underwriter")}
                    </td>
                    <td
                      className="border-bottom-1 border-blue-700"
                      id="underwriter"
                    ></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="card p-3 shadow-3 border-round-lg mt-3 bg-card">
              <table className="w-full">
                <tbody className="text-sm">
                  <tr className="text-yellow-500 font-bold">
                    <td
                      className="py-1 border-bottom-1 border-blue-700"
                      colSpan="2"
                    >
                      {t("Company Profile")}
                    </td>
                  </tr>
                  <tr>
                    <td className="py-1 border-bottom-1 border-blue-700 text-blue">
                      {t("No. of Staff")}
                    </td>
                    <td className=" border-bottom-1 border-blue-700">
                      {stockInfomation.companyProfile &&
                        stockInfomation.companyProfile.noStaff}
                    </td>
                  </tr>
                  <tr>
                    <td className="py-1 border-bottom-1 border-blue-700 text-blue">
                      {t("Substantial Shareholders")}
                    </td>
                    <td
                      className=" border-bottom-1 border-blue-700"
                      id="sub-share"
                    ></td>
                  </tr>
                  <tr>
                    <td className="py-1 border-bottom-1 border-blue-700 text-blue">
                      {t("Shareholder's Structure")}
                    </td>
                    <td
                      className=" border-bottom-1 border-blue-700"
                      id="holder-structure"
                    ></td>
                  </tr>
                  <tr>
                    <td className="py-1 border-bottom-1 border-blue-700 text-blue">
                      {t("Business Highlight")}
                    </td>
                    <td
                      className=" border-bottom-1 border-blue-700"
                      id="business-highlight"
                      onClick={onShowDialog}
                    >
                      Read More
                    </td>
                  </tr>
                  <tr>
                    <td className="py-1 border-bottom-1 border-blue-700 text-blue">
                      {t("Board of Directors")}{" "}
                      {icode == "KH1000010004"
                        ? t("(As of 31 December 2021)")
                        : t("(BOD)")}
                    </td>
                    <td className=" border-bottom-1 border-blue-700" id="bod">
                      <Bod icode={icode}></Bod>
                    </td>
                  </tr>
                  <tr>
                    <td className="py-1 border-bottom-1 border-blue-700 text-blue">
                      {t("Company's Website")}
                    </td>
                    <td className=" border-bottom-1 border-blue-700">
                      {stockInfomation.companyProfile &&
                        stockInfomation.companyProfile.website}
                    </td>
                  </tr>
                  <tr>
                    <td
                      className="border-bottom-1 border-blue-700"
                      colSpan="2"
                      id="company-note"
                    ></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-12 md:col-6 md:pr-2">
            <div className="card p-3 shadow-3 border-round-lg bg-card ">
              <table className="">
                <tbody className="text-start text-sm">
                  <tr className="text-yellow-500 font-bold">
                    <td className="py-1 border-bottom-1 border-blue-700 w-3">
                      {t("Annual Trading Statistics")}
                    </td>
                    {stockInfomation.yearly &&
                      stockInfomation.yearly.map((v, k) => (
                        <td
                          key={k}
                          className="text-right  border-bottom-1 border-blue-700 w-3"
                        >
                          {v ? v : ""}
                        </td>
                      ))}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue  border-bottom-1 border-blue-700">
                      {t("Market Cap. (M. KHR)")}&nbsp;
                      <span className="vertical-align-super mkc text-xs text-yellow-500">
                        (1)
                      </span>
                      <Tooltip
                        target=".mkc"
                        position="right"
                        event="both"
                        title="Chairman"
                      >
                        {t("(1) Market Cap. = listed shares * current price")}
                      </Tooltip>
                    </td>
                    {stockInfomation.annualTradingStatic &&
                      stockInfomation.annualTradingStatic.market_cap.map(
                        (v, k) => (
                          <td
                            key={k}
                            className="text-right  border-bottom-1 border-blue-700"
                          >
                            {v != null
                              ? v.toLocaleString("en-US", {
                                  maximumFractionDigits: 0,
                                })
                              : "-"}
                          </td>
                        )
                      )}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      {t("Full Market Cap. (M. KHR)")}&nbsp;
                      <span className="vertical-align-super fmkc text-xs text-yellow-500">
                        (2)
                      </span>
                      <Tooltip
                        target=".fmkc"
                        position="right"
                        event="both"
                        title="Chairman"
                      >
                        {t(
                          "(2) Full Market Cap. = total issued shares * current price"
                        )}
                      </Tooltip>
                    </td>
                    {stockInfomation.annualTradingStatic &&
                      stockInfomation.annualTradingStatic.full_market_cap.map(
                        (v, k) => (
                          <td
                            key={k}
                            className="text-right border-bottom-1 border-blue-700"
                          >
                            {v ? v.toLocaleString("en-US") : "-"}
                          </td>
                        )
                      )}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      {t("Last Price")}
                    </td>
                    {stockInfomation.annualTradingStatic &&
                      stockInfomation.annualTradingStatic.last_price.map(
                        (v, k) => (
                          <td
                            key={k}
                            className="text-right border-bottom-1 border-blue-700"
                          >
                            {v != null ? v.toLocaleString("en-US") : "-"}
                          </td>
                        )
                      )}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      {t("% Change")}
                    </td>
                    {stockInfomation.annualTradingStatic &&
                      stockInfomation.annualTradingStatic.change.map((v, k) => (
                        <td
                          key={k}
                          className="text-right border-bottom-1 border-blue-700"
                        >
                          {v != null ? v : "-"}
                        </td>
                      ))}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      {t("Avg. Price")}
                    </td>
                    {stockInfomation.annualTradingStatic &&
                      stockInfomation.annualTradingStatic.avg_price.map(
                        (v, k) => (
                          <td
                            key={k}
                            className="text-right border-bottom-1 border-blue-700"
                          >
                            {v != null
                              ? v.toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                              : "-"}
                          </td>
                        )
                      )}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      {t("High")}
                    </td>
                    {stockInfomation.annualTradingStatic &&
                      stockInfomation.annualTradingStatic.high.map((v, k) => (
                        <td
                          key={k}
                          className="text-right border-bottom-1 border-blue-700"
                        >
                          {v != null ? v.toLocaleString("en-US") : "-"}
                        </td>
                      ))}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      {t("Low")}
                    </td>
                    {stockInfomation.annualTradingStatic &&
                      stockInfomation.annualTradingStatic.low.map((v, k) => (
                        <td
                          key={k}
                          className="text-right border-bottom-1 border-blue-700"
                        >
                          {v != null ? v.toLocaleString("en-US") : "-"}
                        </td>
                      ))}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      {t("Value/Day")}
                    </td>
                    {stockInfomation.annualTradingStatic &&
                      stockInfomation.annualTradingStatic.val_day.map(
                        (v, k) => (
                          <td
                            key={k}
                            className="text-right border-bottom-1 border-blue-700"
                          >
                            {v != null
                              ? v.toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                              : "-"}
                          </td>
                        )
                      )}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      {t("Turnover Ratio")}&nbsp;
                      <span className="vertical-align-super tr text-xs text-yellow-500">
                        (3)
                      </span>
                      <Tooltip
                        target=".tr"
                        position="right"
                        event="both"
                        title="Chairman"
                      >
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t("TurnOver Tooltip"),
                          }}
                        ></span>
                      </Tooltip>
                    </td>
                    {stockInfomation.annualTradingStatic &&
                      stockInfomation.annualTradingStatic.turn_over.map(
                        (v, k) => (
                          <td
                            key={k}
                            className="text-right border-bottom-1 border-blue-700"
                          >
                            {v ? v.toFixed(2) + " %" : "-"}
                          </td>
                        )
                      )}
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="card p-3 shadow-3 border-round-lg mt-3 bg-card">
              <table className="w-full">
                <tbody className="text-start text-sm">
                  <tr className="text-yellow-500 font-bold">
                    <td
                      className="py-1 border-bottom-1 border-blue-700"
                      colSpan="4"
                    >
                      {t("Valuation Ratios")}
                    </td>
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700 w-3">
                      {t("P/E")}&nbsp;
                      <span className="vertical-align-super pe text-xs text-yellow-500">
                        (4)
                      </span>
                      <Tooltip
                        target=".pe"
                        position="right"
                        event="both"
                        title="Chairman"
                      >
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t(
                              "P/E = Average price of the year / Earning per share of the year"
                            ),
                          }}
                        ></span>
                      </Tooltip>
                    </td>
                    {stockInfomation.valuationRatios &&
                      stockInfomation.valuationRatios.pe.map((v, k) => (
                        <td
                          key={k}
                          className="text-right border-bottom-1 border-blue-700 w-3"
                        >
                          {v ? v.toFixed(2) : "-"}
                        </td>
                      ))}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      {t("P/BV")}&nbsp;
                      <span className="vertical-align-super pbv text-xs text-yellow-500">
                        (5)
                      </span>
                      <Tooltip
                        target=".pbv"
                        position="right"
                        event="both"
                        title="Chairman"
                      >
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t(
                              "P/BV = Last price / Book value per share"
                            ),
                          }}
                        ></span>
                      </Tooltip>
                    </td>
                    {stockInfomation.valuationRatios &&
                      stockInfomation.valuationRatios.pbv.map((v, k) => (
                        <td
                          key={k}
                          className="text-right border-bottom-1 border-blue-700"
                        >
                          {v ? v.toFixed(2) : "-"}
                        </td>
                      ))}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      {t("DIV Yld")}&nbsp;
                      <span className="vertical-align-super div text-xs text-yellow-500">
                        (6)
                      </span>
                      <Tooltip
                        target=".div"
                        position="right"
                        event="both"
                        title="Chairman"
                      >
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t(
                              "DIV Yld = Cash DIV.per Shr / Last price of stock"
                            ),
                          }}
                        ></span>
                      </Tooltip>
                    </td>
                    {stockInfomation.valuationRatios &&
                      stockInfomation.valuationRatios.div.map((v, k) => (
                        <td
                          key={k}
                          className="text-right border-bottom-1 border-blue-700"
                        >
                          {v ? v : "-"}
                        </td>
                      ))}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      {t("DPR")}&nbsp;
                      <span className="vertical-align-super dpr text-xs text-yellow-500">
                        (7)
                      </span>
                      <Tooltip
                        target=".dpr"
                        position="right"
                        event="both"
                        title="Chairman"
                      >
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t("DPR = Total Dividend/Net Income"),
                          }}
                        ></span>
                      </Tooltip>
                    </td>
                    {stockInfomation.valuationRatios &&
                      stockInfomation.valuationRatios.dpr.map((v, k) => (
                        <td
                          key={k}
                          className="text-right border-bottom-1 border-blue-700"
                        >
                          {v ? v.toLocaleString("en-US") : "-"}
                        </td>
                      ))}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      {t("Cash DIV./Shr")}
                    </td>
                    {stockInfomation.valuationRatios &&
                      stockInfomation.valuationRatios.cash_div.map((v, k) => (
                        <td
                          key={k}
                          className="text-right border-bottom-1 border-blue-700"
                        >
                          {v ? v.toFixed(2) : "-"}
                        </td>
                      ))}
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="card p-3 shadow-3 border-round-lg mt-3 bg-card">
              <table className="w-full">
                <tbody className="text-start text-sm">
                  <tr className="text-yellow-500 font-bold">
                    <td
                      className="py-1 border-bottom-1 border-blue-700"
                      colSpan="4"
                    >
                      {t("Performance Ratios")}
                    </td>
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700 w-3">
                      {t("ROE")}&nbsp;
                      <span className="vertical-align-super roe text-xs text-yellow-500">
                        (8)
                      </span>
                      <Tooltip
                        target=".roe"
                        position="right"
                        event="both"
                        title="Chairman"
                      >
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t(
                              "ROE = Net Income / AVG. Shareholders Equity<br/> * AVG. Shareholders Equity = (Equity of Previous Year + Equity of Current Year) / 2"
                            ),
                          }}
                        ></span>
                      </Tooltip>
                    </td>
                    {stockInfomation.performanceRatios &&
                      stockInfomation.performanceRatios.roe.map((v, k) => (
                        <td
                          key={k}
                          className="text-right border-bottom-1 border-blue-700 w-3"
                        >
                          {v ? v : "-"}
                        </td>
                      ))}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      {t("ROA")}&nbsp;
                      <span className="vertical-align-super roa text-xs text-yellow-500">
                        (9)
                      </span>
                      <Tooltip
                        target=".roa"
                        position="right"
                        event="both"
                        title="Chairman"
                      >
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t(
                              "ROA = Net Income/AVG. Assets <br/> * AVG. Assets = (Assets of Previous Year + Assets of Current Year) / 2"
                            ),
                          }}
                        ></span>
                      </Tooltip>
                    </td>
                    {stockInfomation.performanceRatios &&
                      stockInfomation.performanceRatios.roa.map((v, k) => (
                        <td
                          key={k}
                          className="text-right border-bottom-1 border-blue-700"
                        >
                          {v ? v : "-"}
                        </td>
                      ))}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      {t("Debt Ratio")}&nbsp;
                      <span className="vertical-align-super dr text-xs text-yellow-500">
                        (10)
                      </span>
                      <Tooltip
                        target=".dr"
                        position="right"
                        event="both"
                        title="Chairman"
                      >
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t(
                              "Debt Ratio = average liability / average asset"
                            ),
                          }}
                        ></span>
                      </Tooltip>
                    </td>
                    {stockInfomation.performanceRatios &&
                      stockInfomation.performanceRatios.deptRatio.map(
                        (v, k) => (
                          <td
                            key={k}
                            className="text-right border-bottom-1 border-blue-700"
                          >
                            {v ? v : "-"}
                          </td>
                        )
                      )}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      {t("Current Ratio")}&nbsp;
                      <span className="vertical-align-super cr text-xs text-yellow-500">
                        (11)
                      </span>
                      <Tooltip
                        target=".cr"
                        position="right"
                        event="both"
                        title="Chairman"
                      >
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t(
                              "Current Ratio = Current Assets / Current Liabilities"
                            ),
                          }}
                        ></span>
                      </Tooltip>
                    </td>
                    {stockInfomation.performanceRatios &&
                      stockInfomation.performanceRatios.currentRatio.map(
                        (v, k) => (
                          <td
                            key={k}
                            className="text-right border-bottom-1 border-blue-700"
                          >
                            {v ? v : "-"}
                          </td>
                        )
                      )}
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="card p-3 shadow-3 border-round-lg mt-3 bg-card">
              <table className="w-full">
                <tbody className="text-start text-sm">
                  <tr className="text-yellow-500 font-bold">
                    <td className="py-1" colSpan={3}>
                      {t("Financial Statement Summary")}
                    </td>
                    <td className="text-right">{t("(Mil. KHR)")}</td>
                  </tr>
                  <tr className="text-yellow-500 font-bold">
                    <td className="py-1 ">{t("Balance Sheet")}</td>
                    {stockInfomation.yearly &&
                      stockInfomation.yearly.map((v, k) => (
                        <td key={k} className="text-right">
                          {v ? v : ""}
                        </td>
                      ))}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700 w-3">
                      {t("Assets")}
                    </td>
                    {stockInfomation.balanceSheet &&
                      stockInfomation.balanceSheet.asset.map((v, k) => (
                        <td
                          key={k}
                          className="text-right border-bottom-1 border-blue-700 w-3"
                        >
                          {v
                            ? v.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : "-"}
                        </td>
                      ))}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      &nbsp;• {t("PPE")}
                    </td>
                    {stockInfomation.balanceSheet &&
                      stockInfomation.balanceSheet.ppe.map((v, k) => (
                        <td
                          key={k}
                          className="text-right border-bottom-1 border-blue-700"
                        >
                          {v
                            ? v.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : "-"}
                        </td>
                      ))}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      &nbsp;• {t("Current Asset")}
                    </td>
                    {stockInfomation.balanceSheet &&
                      stockInfomation.balanceSheet.curAsset.map((v, k) => (
                        <td
                          key={k}
                          className="text-right border-bottom-1 border-blue-700"
                        >
                          {v
                            ? v.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : "-"}
                        </td>
                      ))}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      &nbsp;• {t("Investory")}
                    </td>
                    {stockInfomation.balanceSheet &&
                      stockInfomation.balanceSheet.investory.map((v, k) => (
                        <td
                          key={k}
                          className="text-right border-bottom-1 border-blue-700"
                        >
                          {v
                            ? v.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : "-"}
                        </td>
                      ))}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      &nbsp;• {t("A/R")}
                    </td>
                    {stockInfomation.balanceSheet &&
                      stockInfomation.balanceSheet.ar.map((v, k) => (
                        <td
                          key={k}
                          className="text-right border-bottom-1 border-blue-700"
                        >
                          {v
                            ? v.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : "-"}
                        </td>
                      ))}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      &nbsp;• {t("Cash")}
                    </td>
                    {stockInfomation.balanceSheet &&
                      stockInfomation.balanceSheet.cash.map((v, k) => (
                        <td
                          key={k}
                          className="text-right border-bottom-1 border-blue-700"
                        >
                          {v
                            ? v.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : "-"}
                        </td>
                      ))}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      {t("Equity")}
                    </td>
                    {stockInfomation.balanceSheet &&
                      stockInfomation.balanceSheet.equity.map((v, k) => (
                        <td
                          key={k}
                          className="text-right border-bottom-1 border-blue-700"
                        >
                          {v
                            ? v.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : "-"}
                        </td>
                      ))}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      &nbsp;• {t("Share Cap")}
                    </td>
                    {stockInfomation.balanceSheet &&
                      stockInfomation.balanceSheet.shareCap.map((v, k) => (
                        <td
                          key={k}
                          className="text-right border-bottom-1 border-blue-700"
                        >
                          {v
                            ? v.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : "-"}
                        </td>
                      ))}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      &nbsp;• {t("Retained Earnings")}
                    </td>
                    {stockInfomation.balanceSheet &&
                      stockInfomation.balanceSheet.retainedEarning.map(
                        (v, k) => (
                          <td
                            key={k}
                            className="text-right border-bottom-1 border-blue-700"
                          >
                            {v
                              ? v.toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                              : "-"}
                          </td>
                        )
                      )}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      {t("Liabilities")}
                    </td>
                    {stockInfomation.balanceSheet &&
                      stockInfomation.balanceSheet.liabilities.map((v, k) => (
                        <td
                          key={k}
                          className="text-right border-bottom-1 border-blue-700"
                        >
                          {v
                            ? v.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : "-"}
                        </td>
                      ))}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      &nbsp;• {t("Current Liabilities")}
                    </td>
                    {stockInfomation.balanceSheet &&
                      stockInfomation.balanceSheet.curLiablities.map((v, k) => (
                        <td
                          key={k}
                          className="text-right border-bottom-1 border-blue-700"
                        >
                          {v
                            ? v.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : "-"}
                        </td>
                      ))}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      &nbsp;• {t("A/P")}
                    </td>
                    {stockInfomation.balanceSheet &&
                      stockInfomation.balanceSheet.ap.map((v, k) => (
                        <td
                          key={k}
                          className="text-right border-bottom-1 border-blue-700"
                        >
                          {v
                            ? v.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : "-"}
                        </td>
                      ))}
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="card p-3 shadow-3 border-round-lg mt-3 bg-card">
              <table className="w-full">
                <tbody className="text-start text-sm">
                  <tr className="text-yellow-500 font-bold">
                    <td className="py-1" colSpan="4">
                      {t("Income Statement")}
                    </td>
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700 w-3">
                      {t("Revenue")}
                    </td>
                    {stockInfomation.incomeStatement &&
                      stockInfomation.incomeStatement.revenue.map((v, k) => (
                        <td
                          key={k}
                          className="text-right border-bottom-1 border-blue-700 w-3"
                        >
                          {v
                            ? v.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : "-"}
                        </td>
                      ))}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      {t("Gross Profit")}
                    </td>
                    {stockInfomation.incomeStatement &&
                      stockInfomation.incomeStatement.grossProfit.map(
                        (v, k) => (
                          <td
                            key={k}
                            className="text-right border-bottom-1 border-blue-700"
                          >
                            {v
                              ? v.toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                              : "-"}
                          </td>
                        )
                      )}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      {t("EBIT")}
                    </td>
                    {stockInfomation.incomeStatement &&
                      stockInfomation.incomeStatement.ebit.map((v, k) => (
                        <td
                          key={k}
                          className="text-right border-bottom-1 border-blue-700"
                        >
                          {v
                            ? v.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : "-"}
                        </td>
                      ))}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      {t("Net Income")}
                    </td>
                    {stockInfomation.incomeStatement &&
                      stockInfomation.incomeStatement.netIncome.map((v, k) => (
                        <td
                          key={k}
                          className="text-right border-bottom-1 border-blue-700"
                        >
                          {v
                            ? v.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : "-"}
                        </td>
                      ))}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      {t("EPS (KHR)")}&nbsp;
                      <span className="vertical-align-super cr text-xs text-yellow-500">
                        (12)
                      </span>
                      <Tooltip
                        target=".cr"
                        position="right"
                        event="both"
                        title="Chairman"
                      >
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t(
                              "EPS before the year of IPO = Net Income / No. of shares before IPO<br/>EPS in the year of IPO = Net Income / Weighted average No. of shares in the year of IPO based on initial listing date"
                            ),
                          }}
                        ></span>
                      </Tooltip>
                    </td>
                    {stockInfomation.incomeStatement &&
                      stockInfomation.incomeStatement.eps.map((v, k) => (
                        <td
                          key={k}
                          className="text-right border-bottom-1 border-blue-700"
                        >
                          {v
                            ? v.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : "-"}
                        </td>
                      ))}
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="card p-3 shadow-3 border-round-lg mt-3 bg-card">
              <table className="w-full">
                <tbody className="text-start text-sm">
                  <tr className="text-yellow-500 font-bold">
                    <td className="py-1" colSpan="4">
                      {t("Cash Flow Statement")}
                    </td>
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700 w-3">
                      {t("Operating Cash Flow")}
                    </td>
                    {stockInfomation.cashFlowStatement &&
                      stockInfomation.cashFlowStatement.operatingCashFlow.map(
                        (v, k) => (
                          <td
                            key={k}
                            className="text-right border-bottom-1 border-blue-700 w-3"
                          >
                            {v ? v : "-"}
                          </td>
                        )
                      )}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      {t("Investing Cash Flow")}
                    </td>
                    {stockInfomation.cashFlowStatement &&
                      stockInfomation.cashFlowStatement.investingCashFlow.map(
                        (v, k) => (
                          <td
                            key={k}
                            className="text-right border-bottom-1 border-blue-700"
                          >
                            {v ? v : "-"}
                          </td>
                        )
                      )}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      {t("Financing Cash Flow")}
                    </td>
                    {stockInfomation.cashFlowStatement &&
                      stockInfomation.cashFlowStatement.financingCashFlow.map(
                        (v, k) => (
                          <td
                            key={k}
                            className="text-right border-bottom-1 border-blue-700"
                          >
                            {v ? v : "-"}
                          </td>
                        )
                      )}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      {t("Net Cash Flow")}
                    </td>
                    {stockInfomation.cashFlowStatement &&
                      stockInfomation.cashFlowStatement.netCashFlow.map(
                        (v, k) => (
                          <td
                            key={k}
                            className="text-right border-bottom-1 border-blue-700"
                          >
                            {v ? v : "-"}
                          </td>
                        )
                      )}
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      {t("Auditing Firm")}
                    </td>
                    <td
                      className="pe-1 text-start border-bottom-1 border-blue-700"
                      colSpan="3"
                    >
                      {stockInfomation.cashFlowStatement &&
                        (stockInfomation.cashFlowStatement.audit
                          ? stockInfomation.cashFlowStatement.audit
                          : "-")}
                    </td>
                  </tr>
                  <tr>
                    <td className="py-1 text-blue border-bottom-1 border-blue-700">
                      {t("Financial Reports")}
                    </td>
                    <td
                      className="pe-1 text-start border-bottom-1 border-blue-700"
                      colSpan="3"
                      id="financial-report"
                    >
                      {stockInfomation.cashFlowStatement &&
                        (stockInfomation.cashFlowStatement.finanReport
                          ? stockInfomation.cashFlowStatement.finanReport
                          : "-")}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <Dialog
        header={t("Business Highlight")}
        headerClassName="text-yellow-500 border-bottom-1 border-blue-700 bg-none pb-0 text-2xl"
        contentClassName="bg-none"
        className="w-11 md:w-8 text-white border-round-lg"
        style={{
          backgroundImage:
            "linear-gradient(to bottom, rgba(18, 83, 134, 1), rgba(13, 60, 97, 1))",
        }}
        visible={dialogVisible}
        onHide={() => setDialogVisible(false)}
      >
        <div
          className="m-0 text-white line-height-3"
          id="business-highlight-dialog"
          dangerouslySetInnerHTML={{ __html: dialogContent }}
        ></div>
      </Dialog>
    </>
  );
}
